var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg103(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase (1) 1",
    clipPath: "url(#clip0_280_147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.1666 7.08405H24.0834V5.66734C24.0834 4.10473 22.8127 2.83398 21.25 2.83398H12.75C11.1874 2.83398 9.91664 4.10467 9.91664 5.66734V7.08398H2.83336C1.27068 7.08405 0 8.35473 0 9.91734V14.1673C0 15.73 1.27068 17.0007 2.83336 17.0007H14.1667V16.2923C14.1667 15.9008 14.4835 15.584 14.8751 15.584H19.1251C19.5166 15.584 19.8334 15.9008 19.8334 16.2923V17.0007H31.1668C32.7293 17.0007 34 15.73 34 14.1673V9.91734C34 8.35473 32.7293 7.08405 31.1666 7.08405ZM21.25 7.08405H12.75V5.66734H21.25V7.08405Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.6071 17.7643C33.3657 17.6446 33.0772 17.6723 32.8641 17.8341C32.3606 18.2153 31.7739 18.4166 31.1666 18.4166H19.8334V20.5416C19.8334 20.9331 19.5165 21.2499 19.125 21.2499H14.875C14.4835 21.2499 14.1666 20.9331 14.1666 20.5416V18.4166H2.83336C2.226 18.4166 1.63944 18.2153 1.13581 17.8341C0.922051 17.6709 0.634313 17.6432 0.392859 17.7643C0.152203 17.884 0 18.1295 0 18.3986V28.3333C0 29.8959 1.27068 31.1666 2.83336 31.1666H31.1667C32.7293 31.1666 34.0001 29.896 34.0001 28.3333V18.3986C34 18.1295 33.8478 17.884 33.6071 17.7643Z",
    fill: "#00FFF0"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg103);
export default __webpack_public_path__ + "static/media/svg1-03.ba160f6555841543b5d460289659b041.svg";
export { ForwardRef as ReactComponent };